var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zp-content"},[_c('img-upload',{ref:"inspectionDocumentUrl",staticClass:"file-upload",attrs:{"imageUrl":_vm.inspectionDocumentUrl,"limit":9,"isType":2,"title":"支持扩展名：doc .docx .pdf .xls .jpg"},on:{"downloadALink":_vm.downloadALink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }